import React, { useCallback } from 'react'
import Icon from '../../icon'
import classnames from 'classnames/bind'
import styles from './styles.scss'
import type { ButtonWidth } from '../types'
const cx = classnames.bind(styles)

type FilterButtonProps = {
  label: React.ReactNode
  width: ButtonWidth
  isFilterSelected: boolean
  onOpen: (isOpen: boolean) => void
  isOpen: boolean
  onReset: () => void
  elmId: string
}

const FilterButton: React.FunctionComponent<FilterButtonProps> = ({
  label,
  width,
  isFilterSelected,
  onOpen,
  isOpen,
  onReset,
  elmId,
}) => {
  const onClickRightButton = useCallback(() => {
    if (isFilterSelected) {
      onReset()
      onOpen(false)
    } else {
      onOpen(!isOpen)
    }
  }, [isFilterSelected, isOpen, onReset, onOpen])

  return (
    <button
      data-elm-id={`${elmId}`}
      aria-expanded={isOpen}
      aria-haspopup='dialog'
      className={cx(
        'filter-button',
        { active: isFilterSelected },
        { 'fluid-width': width === 'fluid' }
      )}
    >
      <div className={cx('container')}>
        <div className={cx('label')} onClick={() => onOpen(!isOpen)}>
          <div data-elm-id={`${elmId}_left`} className={cx('label-text')}>
            {label}
          </div>
        </div>
        <div
          className={cx('right-button')}
          onClick={onClickRightButton}
          data-elm-id={`${elmId}_right`}
        >
          {isFilterSelected ? (
            <Icon color='white' iconStyle='solid' name='xmark' size='medium' />
          ) : (
            <Icon
              color='gray'
              iconStyle='solid'
              name={isOpen ? 'chevron-up' : 'chevron-down'}
              size='medium'
            />
          )}
        </div>
      </div>
    </button>
  )
}

export default FilterButton
